const STORAGE_KEY = 'payvault_locale';
const SUPPORTED_LOCALES = ['zh-TW', 'zh-CN', 'en', 'ja', 'ko', 'th', 'vi'];

export function getStoredLocale() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (SUPPORTED_LOCALES.includes(stored)) {
    return stored;
  }
  const lang = navigator.language || navigator.userLanguage || '';
  const lower = lang.toLowerCase();
  if (lower.startsWith('zh-tw')) return 'zh-TW';
  if (lower.startsWith('zh-cn') || lower === 'zh') return 'zh-CN';
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('ja')) return 'ja';
  if (lower.startsWith('ko')) return 'ko';
  if (lower.startsWith('th')) return 'th';
  if (lower.startsWith('vi')) return 'vi';
  return 'zh-TW';
}

export const loadStoredLocale = getStoredLocale;

export function setStoredLocale(locale) {
  if (SUPPORTED_LOCALES.includes(locale)) {
    localStorage.setItem(STORAGE_KEY, locale);
  }
}
